export default __webpack_public_path__ + "f326276b354afe922f9f8b1725ee39b2.png";